/* globals localStorage */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DOMPurify from 'dompurify';

const useStyles = makeStyles(() => ({
  outerContainer: {
    border: '1px solid black',
    margin: '15px',
  },
  logo: {
    margin: '15px auto',
    textAlign: 'center',
    padding: '15px',
    width: '100px',
    backgroundColor: 'white',
  },
  innerContainer: {
    color: '#74787e',
    backgroundColor: 'white',
    margin: '30px 55px',
    padding: '20px 60px',
  },
  button: {
    textAlign: 'center',
    color: 'white',
    padding: '12px',
    borderRadius: '4px',
    margin: '30px auto',
    width: '200px',
  },
  footer: {
    color: 'white',
    fontSize: '.8rem',
    textAlign: 'center',
    marginBottom: '15px',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    textAlign: 'center',
  },
}));

const WelcomeEmailPreview = (props) => {
  const {
    backgroundColor,
    buttonColor,
    clientUrl,
    email,
    phoneRaw,
    phone,
    clientName,
    address,
    welcomeMessage,
  } = props;
  const classes = useStyles();
  const userFirstName = JSON.parse(localStorage.getItem('user')).first_name;
  return (
    <div
      className={classes.outerContainer}
      style={{ backgroundColor: backgroundColor || '#d1d3d4' }}
    >
      <div className={classes.logo}>
        <strong> YOUR LOGO HERE</strong>
      </div>
      <div className={classes.innerContainer}>
        <p>
          Welcome to {clientName}, {userFirstName}! We&apos;re here to make car
          maintenance easy, convenient, and reliable so you can skip the auto
          shop and focus on what matters. It&apos;s like a pit crew, just for
          you.
        </p>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(welcomeMessage),
          }}
        />
        <div
          className={classes.button}
          style={{ backgroundColor: buttonColor || '#3869d4' }}
        >
          <strong>Book Your Next Service</strong>
        </div>
        <p>
          We hope to see your car soon!
          <br />
          The {clientName} Team
        </p>
        <p>
          <strong>
            P.S. If you have any questions about {clientName}, just reply to
            this email! Our team is always ready to help!
          </strong>
        </p>
      </div>
      <div className={classes.footer}>
        <strong>
          <a
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            href={clientUrl || '<client url>'}
          >
            {clientUrl}
          </a>
        </strong>{' '}
        |{' '}
        <a className={classes.link} href={`mailto:${email}`}>
          {email || '<client email>'}
        </a>{' '}
        |{' '}
        <a className={classes.link} href={`tel:+${phoneRaw}`}>
          {phone || '<client phone>'}
        </a>
        <br />
        <br />
        {clientName || '<client name>'} | {address || '<client address>'}
      </div>
    </div>
  );
};

export default WelcomeEmailPreview;
